module.exports = __webpack_public_path__ + "static/3-Tri-05-79717358ae2ec511126e0c3628d99849.png";